import React from 'react'
import Picklist from '../configuration/picklist/Picklist'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

const MainPicklist = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Picklist'),
      component: <Picklist />,
      to: '/configuration/picklist'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainPicklist
